const sortUsersByLastMessage = (users) => {
  return users
    .slice()
    .sort((a, b) => b.lastMessageTimestamp - a.lastMessageTimestamp);
};

module.exports = {
  sortUsersByLastMessage,
};
